'use client';

// The absorption chart for this /tools page, hosted by the room dock's own
// `Chart.tsx`. This used to hand-roll the canvas-sizing + redraw +
// ResizeObserver loop `Chart.tsx` already provides, on the claim that
// `Chart.tsx` "needs EditorContext, which a plain landing/tools page doesn't
// mount" — that claim doesn't hold: `Chart.tsx` imports no `useEditor` (only
// `Charts.tsx`, the room-dock's section wrapper, does). `.guided-theme`
// scopes the `--ed-*` tokens `Chart.tsx` paints its chrome with — see
// ToolFreqChart.tsx's header comment for why that's a safe, established
// no-op for a page whose own `--app-*` tokens alias the exact same `--rt-*`
// values. The paint itself is still `drawAbsorption` from
// `web/src/components/room/charts/chartDraw.ts`, unchanged, per AGENTS.md's
// chart rule.

import Chart from '@/components/room/charts/Chart';
import { drawAbsorption } from '@/components/room/charts/chartDraw';
import { tokensAt } from '@/lib/theme/tokens';

interface Props {
  freqs: number[];
  alpha: number[];
  fMin: number;
  fMax: number;
}

export default function AbsorptionCanvas({ freqs, alpha, fMin, fMax }: Props) {
  return (
    <div className="guided-theme">
      <Chart
        title="Absorption vs. frequency"
        hideHeader
        testId="porous-absorber-canvas"
        draw={
          freqs.length
            ? (canvas) => drawAbsorption(canvas, { freqs, alpha, fMin, fMax, accent: tokensAt(canvas).accent })
            : null
        }
      />
    </div>
  );
}
